import classnames from 'classnames';
import { FC, forwardRef, HTMLAttributes, ReactNode, Ref } from 'react';

// xs: will be applied always unless you override on other screen sizes

type TagNames = 'div' | 'dd' | 'dl' | 'dt';

export type ColumnProps = {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  order?: number | 'first' | 'last';
  children?: ReactNode;
  className?: string;
  component?: TagNames;
};

type Element = HTMLDivElement & HTMLDListElement & HTMLElement;

type ComponentProps = {
  tagName?: TagNames;
  children: ReactNode;
  ref?: Ref<Element>;
} & HTMLAttributes<Element>;

const Component: FC<ComponentProps> = ({
  tagName: Wrapper = 'div',
  children,
  ...rest
}) => {
  return <Wrapper {...rest}>{children}</Wrapper>;
};

export const Column: FC<ColumnProps> = forwardRef<Element, ColumnProps>(
  ({ md, sm, lg, xl, order, children, className, xs = 12, component }, ref) => (
    <Component
      tagName={component}
      className={classnames(className, `col-${xs}`, {
        [`col-sm-${sm}`]: Boolean(sm),
        [`col-md-${md}`]: Boolean(md),
        [`col-lg-${lg}`]: Boolean(lg),
        [`col-xl-${xl}`]: Boolean(xl),
        [`order-md-${order}`]: Boolean(order)
      })}
      ref={ref}>
      {children}
    </Component>
  )
);
